/**
 * JSON.stringify replacement that handles BigInt values by converting them to strings.
 * This is essential for DeFi applications where BigInt values are common (token amounts, etc.)
 *
 * @param value - The value to stringify
 * @param replacer - Optional replacer function (same as JSON.stringify)
 * @param space - Optional spacing for formatting (same as JSON.stringify)
 * @returns JSON string with BigInt values converted to strings
 */
export function jsonStringifyDefi(
  value: any,
  replacer?: ((this: any, key: string, value: any) => any) | (string | number)[] | null,
  space: number = 2,
): string {
  return JSON.stringify(
    value,
    (key, val) => {
      // Handle BigInt values
      if (typeof val === "bigint") {
        return val.toString()
      }

      // Apply custom replacer if provided
      if (replacer) {
        if (typeof replacer === "function") {
          // @ts-ignore
          return replacer.call(this, key, val)
        } else if (Array.isArray(replacer)) {
          // Array replacer - only include specified keys
          if (replacer.includes(key)) {
            return val
          }
          return undefined
        }
      }

      return val
    },
    space,
  )
}
